import { UserV2Service } from '@/services/user-v2-service'

const swapKeyMap: Record<string, string> = {
  exs_buy: 'filter_exs_buy',
  exs_sell: 'filter_exs_sell',
  symbols: 'filter_symbols',
  spread_min: 'filter_spread_min',
  funding_min: 'filter_funding_min',
  exclude_selected_symbols: 'filter_exclude_symbols',
  vol24h_long_min: 'filter_vol24h_long_min',
  vol24h_short_min: 'filter_vol24h_short_min',
  max_age_seconds: 'filter_max_age_seconds',
}

const dexCexKeyMap: Record<string, string> = {
  cexs: 'filter_cexs',
  symbols: 'filter_symbols',
  spread_min: 'filter_spread_min',
  exclude_selected_symbols: 'filter_exclude_symbols',
  vol24h_cex_min: 'filter_vol24h_cex_min',
  vol24h_dex_min: 'filter_vol24h_dex_min',
  is_long: 'filter_is_long',
  volumes: 'filter_volumes',
  max_age_seconds: 'filter_max_age_seconds',
}

const dexDexKeyMap: Record<string, string> = {
  symbols: 'filter_symbols',
  chains: 'filter_chains',
  chains_buy: 'filter_chains_buy',
  chains_sell: 'filter_chains_sell',
  spread_min: 'filter_spread_min',
  liquidity_min_usd: 'filter_liquidity_min_usd',
  exclude_selected_symbols: 'filter_exclude_symbols',
  max_age_seconds: 'filter_max_age_seconds',
}

function buildPayload(
  filters: Record<string, any>,
  keyMap: Record<string, string>,
  prefix: string,
): Record<string, any> {
  const result: Record<string, any> = {}
  for (const [key, value] of Object.entries(filters)) {
    if (value === null || value === undefined) continue
    if (Array.isArray(value) && value.length === 0) continue
    if (keyMap[key]) {
      result[`${prefix}${keyMap[key]}`] = value
    }
  }
  return result
}

export function useSaveFilters() {
  const saveSwapFilters = async (filters: Record<string, any>, prefix: string) => {
    const payload = buildPayload(filters, swapKeyMap, prefix)
    if (Object.keys(payload).length > 0) {
      await UserV2Service.saveUserFilters(payload, prefix)
    }
  }

  const saveDexCexFilters = async (filters: Record<string, any>) => {
    const payload = buildPayload(filters, dexCexKeyMap, 'dex_cex_')
    if (Object.keys(payload).length > 0) {
      await UserV2Service.saveUserFilters(payload, 'dex_cex_')
    }
  }

  const saveDexDexFilters = async (filters: Record<string, any>, isCrossChain = false) => {
    const prefix = isCrossChain ? 'dex_dex_cr_' : 'dex_dex_'
    const payload = buildPayload(filters, dexDexKeyMap, prefix)
    if (Object.keys(payload).length > 0) {
      await UserV2Service.saveUserFilters(payload, prefix)
    }
  }

  return { saveSwapFilters, saveDexCexFilters, saveDexDexFilters }
}
